import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={42}
      height={35.027}
      viewBox="0 0 42 35.027"
      {...props}
    >
      <g data-name="Component 41 \u2013 1">
        <text
          data-name="\u0635\u0631\u0641\u0647 \u062C\u0648\u06CC\u06CC"
          transform="translate(15 7)"
          fill="#fff"
          fontSize={6}
          fontFamily="IRANYekanFN-Medium, IRANYekanFN"
          fontWeight={500}
        >
          <tspan x={14.318} y={0}>
            {"\u0635\u0631\u0641\u0647 \u062C\u0648\u06CC\u06CC"}
          </tspan>
        </text>
        <text
          data-name="90%"
          transform="translate(36 8)"
          fill="#fff"
          fontSize={6}
          fontFamily="IRANYekanFN-Medium, IRANYekanFN"
          fontWeight={500}
        >
          <tspan x={5.099} y={0}>
            {"90%"}
          </tspan>
        </text>
        <path
          data-name="Path 7429"
          d="M21.941 33.511a6.222 6.222 0 009.263-6.415l-1.114-7.751-6.7 2.694z"
          fill="rgba(160,212,104,0)"
        />
        <path
          data-name="Path 7430"
          d="M10.926 30.6a7.434 7.434 0 109.091-10.653l-8.656-3.513-1.327 9.232a7.372 7.372 0 00.892 4.934z"
          fill="rgba(96,156,32,0)"
        />
        <path
          data-name="Path 7431"
          d="M31.641 27.075v-.04l-1.114-7.751a.434.434 0 00-.592-.341l-5.134 2.061a.434.434 0 10.324.806l4.614-1.855 1.028 7.153a.436.436 0 00.006.061 5.792 5.792 0 01-8.618 5.967l-.028-.014a7.864 7.864 0 00.812-.71l5.082-1.362a.434.434 0 00-.225-.839l-3.91 1.048a7.862 7.862 0 001-2.1l3.489-.935a.434.434 0 00-.225-.839l-2.567.688.965-1.672 2.04-.547a.434.434 0 00-.225-.839l-1.2.322.924-1.6a.434.434 0 10-.752-.434l-.924 1.6-.322-1.2a.434.434 0 10-.839.225l.547 2.04-.565.978a7.84 7.84 0 00-5.041-7.4h-.008l-1.964-.8a.434.434 0 00-.326.8l1.946.79.027.011a6.979 6.979 0 011.36 12.346l-.729-1.262 1.579-5.895a.434.434 0 10-.839-.225l-1.356 5.063-1.608-2.784 1.1-4.089a.434.434 0 10-.839-.225l-.871 3.251-1.27-2.195.66-2.463a.434.434 0 10-.839-.225l-.435 1.622-1.2-2.079a.434.434 0 10-.752.434l1.2 2.079-1.626-.434a.434.434 0 00-.225.839l2.463.66 1.267 2.194-3.251-.871a.434.434 0 00-.225.839l4.089 1.1 1.607 2.784-5.053-1.358a.434.434 0 00-.225.839l5.895 1.579.728 1.262a6.974 6.974 0 01-10-7.4.421.421 0 00.006-.064l1.24-8.627 2.876 1.167a.434.434 0 00.326-.8l-3.39-1.376a.434.434 0 00-.593.341l-1.335 9.23a.43.43 0 000 .044 7.851 7.851 0 0011.3 8.238l.534.924a.434.434 0 10.752-.434l-.2-.343a6.636 6.636 0 003.064.753 6.711 6.711 0 001.73-.228 6.647 6.647 0 004.854-7.483z"
          fill="#fff"
        />
        <path
          data-name="Path 7432"
          d="M16.367 18.901a.434.434 0 10-.307-.127.437.437 0 00.307.127z"
          fill="#fff"
        />
        <path
          data-name="Path 7433"
          d="M28.066 22.48a.434.434 0 00.7-.51.434.434 0 00-.7.51z"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
